import "./Project1.css";

function Project3() {
  return (
    <div className="project1-cont active">
      <div className="project-header">
        <h2>Abbey House Hotel</h2>
      </div>
      <div className="about-text">
        <p>
            Abbey House Hotel is an innovative custom web application with various custom blocks developed for a travel and hospitality management company. The website has a sleek and user-friendly interface, providing potential clients an immersive visual experience. The project was implemented using JavaScript, jQuery, PHP, CSS, SASS, MySQL and CMS.
            <br/>
            Abbey House was developed under the expert supervision and creative direction of Up Hotel Agency.
        </p>
        <h3 className="project-link">
          <a
            href="https://www.abbeyhousehotel.com"
            target="_blank"
            rel="noreferrer"
          >
            <span>View Site</span>
          </a>
          <br />
        </h3>
      </div>
    </div>
  );
}

export default Project3;
